<!-- 全局搜索 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img">
				<p class="header-title">搜索</p>
			</div>
			<div class="search-box">
				<div class="search-bar">
					<img src="../assets/search-icon.png" class="search-icon">
					<input type="search" value="" placeholder="请输入关键字进行搜索" class="search-input" />
				</div>
				<div class="screen-row">
					筛选
					<img src="../assets/icon-69.png">
				</div>
				<!-- 弹窗 -->
				<!-- <div>
					<div class="mask-layer"></div>
					<div class="search-window">
						<p class="search-window-label">内容形式</p>
						<ul class="search-window-list">
							<li class="active">不限</li>
							<li>视频</li>
							<li>图文</li>
							<li>资料</li>
							<li>供应商</li>
							<li>活动</li>
							<li>招聘</li>
							<li>新闻</li>
							<li>项目/需求</li>
							<li>新闻</li>
						</ul>
						<p class="search-window-label">排序依据</p>
						<ul class="search-window-list">
							<li class="active">综合</li>
							<li>最新</li>
							<li>好评</li>
						</ul>
						<p class="search-window-label">排序依据</p>
						<ul class="search-window-list">
							<li class="active">不限</li>
							<li>一年内</li>
							<li>半年</li>
						</ul>
						<div class="search-window-btn-box">
							<button type="button" class="border-btn">重置</button>
							<button type="button">确定</button>
						</div>
					</div>
				</div> -->
				<!-- 弹窗 -->
			</div>
		</div>

		<ul class="list">
			<li>
				<div class="img-box">
					<img src="../assets/img.png" class="img-box-img">
					<span class="tag">VIP</span>
					<span class="item-time">
						02:34
					</span>
					<span class="item-status">已完结</span>
				</div>
				<div class="item-sidebar">
					<p class="item-title">APAUTOSAR进阶应用应用应用</p>
					<div class="item-sidebar-row">
						<img src="../assets/avatar.png" class="img">
						搞一下汽车电子
					</div>
					<div class="item-sidebar-row-between">
						<div class="item-sidebar-row-left">
							<img src="../assets/play.png" class="play-icon">
							3218
						</div>
					</div>
				</div>
				<button class="circle-btn">
					<img src="../assets/icon-39.png" class="circle-img">
				</button>
			</li>
			<li>
				<div class="img-box2">
					<img src="../assets/icon-19.png" class="img-box2-img">
					<img src="../assets/icon-25.png" class="tag-2">
				</div>
				<div class="item-sidebar-2">
					<div class="item-column">
						<p class="item-name">AP AUTOSAR&自动驾驶</p>
						<p class="item-msg">自动驾驶中使用到的新技术的应用</p>
					</div>
					<button class="circle-btn-2">
						<img src="../assets/icon-39.png" class="circle-img">
					</button>
				</div>
			</li>
		</ul>

		<div class="float-box">
			<button type="button" @click="$router.push('/feedback')">没找到？点我反馈</button>
		</div>


	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				showReport: false,
				showOpenVip: false,
				status: 0
				// 举报参数
				// reportParams: {
				// 	type: 5, // 举报类型（1视频2视频评论3会员,4资料,5图文）
				// 	report_id: 0, // 举报内容的id
				// },
				// params: {
				// 	title: '', // 标题
				// 	sort_type: 1, // 1默认2时间升序3时间降序
				// 	page: 1, // 页数
				// 	page_num: 20, // 每页数
				// },
				// list: [],
				// loading: false,
				// finished: false,

				// isLogin: false,
				// isVip: false,
			};
		},
		mounted() {},
		methods: {},
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 100px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.search-box {
		width: 100%;
		height: 56px;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
		position: relative;
	}

	.search-bar {
		flex: 1;
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 14px;
		margin-right: 8px;
	}

	.search-input {
		flex: 1;
		font-size: 14px;
	}

	.search-input::placeholder {
		color: #7F7F7F;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 16px;
		color: #555555;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}


	.sub-tab-list {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
	}

	.sub-tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 14px;
		color: #555555;
		position: relative;
	}

	.sub-tab-list>li.active {
		font-weight: 500;
		color: #222222;
	}

	.sub-tab-list>li.active::after {
		content: "";
		width: 18px;
		height: 4px;
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
	}

	.tab-icon {
		width: 6px;
		margin-left: 2px;
	}

	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin: 100px 0 0;
		box-sizing: border-box;
	}

	.float-box {
		position: fixed;
		left: 50%;
		transform: translate(-50%, 0);
		bottom: 40px;
		z-index: 499;
	}

	.float-box>button {
		min-width: 175px;
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #2A63F3;
		border-radius: 100px;
		color: #FFFFFF;
		font-size: 18px;
		font-weight: 500;
	}



	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 120px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}

	.screen-row {
		display: flex;
		align-items: center;
		color: #555555;
		font-size: 14px;
		margin-left: 26px;
	}

	.screen-row>img {
		margin-left: 4px;
		width: 6px;
	}

	.mask-layer {
		width: 100%;
		height: calc(100vh - 100px);
		position: fixed;
		top: 100px;
		left: 0;
		z-index: 100;
		background: rgba(0, 0, 0, 0.8);
	}

	.search-window {
		width: 100%;
		position: absolute;
		top: 56px;
		left: 0;
		z-index: 100;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		padding: 0 11px;
		box-sizing: border-box;
	}

	.search-window-label {
		width: 100%;
		color: #222222;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 12px;
		margin-top: 2px;
	}

	.search-window-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.search-window-list>li {
		width: fit-content;
		height: 26px;
		line-height: 26px;
		min-width: 74px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666666;
		font-size: 13px;
		background-color: #F3F3F3;
		margin-right: 16px;
		margin-bottom: 10px;
		border-radius: 100px;
	}

	.search-window-list>li.active {
		color: #2A63F3;
		background-color: #ECF2FF;
		border: 1px solid #2A63F3;
	}

	.search-window-btn-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0 33px;
		box-sizing: border-box;
	}

	.search-window-btn-box>button {
		flex: 1;
		height: 38px;
		line-height: 38px;
		background-color: #2A63F3;
		border-radius: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		font-weight: bold;
		color: #FFFFFF;
		margin-right: 15px;
		box-sizing: border-box;
	}

	.search-window-btn-box>button:last-child {
		margin-right: 0;
	}

	.search-window-btn-box>button.border-btn {
		flex: initial;
		width: 120px;
		border: 1px solid #CCCCCC;
		background-color: #FFFFFF;
		color: #7F7F7F;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 6px 15px;
		box-sizing: border-box;
		/*height: 100%;*/
		overflow: auto;
	}

	.list>li {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		margin-bottom: 20px;
		position: relative;
	}

	.list>li:last-child {
		margin-bottom: 0;
	}

	.img-box {
		width: 150px;
		height: 86px;
		position: relative;
		border-radius: 12px;
		overflow: hidden;
		margin-right: 10px;
	}

	.img-box-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.img-box2 {
		width: 60px;
		height: 60px;
		border-radius: 4px;
		position: relative;
		margin-right: 14px;
	}

	.img-box2-img {
		width: 100%;
		height: 100%;
	}

	.tag {
		position: absolute;
		right: 0;
		top: 0;
		background: linear-gradient(90deg, #FFCD7C, #FFEEBA);
		border-radius: 0 7px 0 7px;
		min-width: 34px;
		height: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #222222;
		font-size: 12px;
		font-weight: bold;
	}

	.tag-2 {
		position: absolute;
		right: 0;
		top: 0;
		background: linear-gradient(90deg, #FFCD7C, #FFEEBA);
		border-radius: 0 4px 0 4px;
		min-width: 20px;
		height: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #222222;
		font-size: 8px;
		font-weight: bold;
	}

	.item-sidebar {
		flex: 1;
		height: 86px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.item-sidebar-2 {
		flex: 1;
		height: 40px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.item-title {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-size: 15px;
		line-height: 21px;
	}

	.item-sidebar-row {
		width: 100%;
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.img {
		width: 12px;
		height: 12px;
		border-radius: 50%;
		margin-right: 4px;
		object-fit: cover;
	}

	.item-sidebar-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item-sidebar-row-left {
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.play-icon {
		width: 12px;
		margin-right: 4px;
	}

	.circle-btn {
		width: 15px;
		height: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		right: 5px;
		bottom: 0;
	}

	.circle-btn-2 {
		width: 15px;
		height: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		right: 5px;
		bottom: 0;
	}

	.circle-img {
		height: 3px;
	}

	.item-time {
		min-width: 36px;
		height: 14px;
		line-height: 14px;
		border-radius: 7px;
		background: rgba(0, 0, 0, 0.8);
		position: absolute;
		right: 8px;
		bottom: 8px;
		color: #FFFFFF;
		font-size: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.item-status {
		height: 14px;
		line-height: 14px;
		padding: 0 6px;
		border-radius: 7px;
		background-color: #2A63F3;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		left: 6px;
		bottom: 8px;
		color: #FFFFFF;
		font-size: 8px;
	}

	.row {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #666666;
		font-size: 10px;
	}

	.item-name {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-size: 15px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.item-msg {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #999999;
		font-size: 10px;
	}
</style>
